module.exports = __webpack_public_path__ + "img/en.4f1b7af5.svg";